module.exports = __webpack_public_path__ + "img/rongyu_tr.c9cf0c49.png";